function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import classnames from "classnames";
import { CLUSTER_TYPE, USE_CASE_TYPE } from "constants/clusters/types";
import { fireHotjarEvents } from "client/services/hotjar-service/hotjar-service";
import { updateUserClustersListWithMultipleClusters } from "services/clusters-service";
import { HP_TAGS_SELECTION } from "constants/clusters";
import { BRAND_BLACK_BACKGROUND_COLOR, SPACE_BLUE_COLOR_NAME, WHITE_COLOR_NAME, WORK_OS_IRIS_COLOR_NAME } from "styles/color-consts";
import colors from "styles/colors";
import { getHoverColor } from "styles/colors-utils";
import { useMemo, useState } from "react";
import { StyledClustersSignup } from "./clusters-signup.scss";
import { trackEvent } from "services/bigbrain-service";
import { SIGNUP_WITH_TAGS } from "constants/bigbrain-event-types";
import ProductSignUp from "segments/desktop/core-components/product-sign-up/product-sign-up";
const LIGHT_THEME_BUTTON_OPACITY = "ee";
const ClustersSignup = (_param)=>{
    var { clusters = [], wasClusterSelected, selectedProducts, buttonColor, removeGradient, buttonSize } = _param, restOfConfig = _object_without_properties(_param, [
        "clusters",
        "wasClusterSelected",
        "selectedProducts",
        "buttonColor",
        "removeGradient",
        "buttonSize"
    ]);
    const [isHover, setIsHover] = useState(false);
    const productType = useMemo(()=>(selectedProducts === null || selectedProducts === void 0 ? void 0 : selectedProducts.length) === 1 ? selectedProducts[0] : null, [
        selectedProducts
    ]);
    const getButtonTextColor = ()=>{
        if (removeGradient) {
            return buttonColor === WHITE_COLOR_NAME ? colors[BRAND_BLACK_BACKGROUND_COLOR] : colors[WHITE_COLOR_NAME];
        }
        if (buttonColor === WHITE_COLOR_NAME && clusters.length === 0) {
            return colors[SPACE_BLUE_COLOR_NAME];
        }
        return colors[WHITE_COLOR_NAME];
    };
    const getButtonColorBySelectedClusters = ()=>{
        if (removeGradient) return colors[buttonColor];
        if ((clusters === null || clusters === void 0 ? void 0 : clusters.length) === 0) {
            return isHover ? getHoverColor(colors[buttonColor]) : colors[buttonColor];
        }
        // if only 1 cluster was selected, fill the button with a gradient built of the same color
        if (clusters.length === 1) {
            const colorName = clusters[0].tagBackgroundColor;
            const color = isHover ? getHoverColor(colors[colorName]) : colors[colorName];
            return `linear-gradient(90deg, ${color}${LIGHT_THEME_BUTTON_OPACITY} 0%, ${color}${LIGHT_THEME_BUTTON_OPACITY} 100%)`;
        }
        let colorsString = ``;
        const chunkSize = 100 / (clusters.length - 1);
        // building the linear gradient string
        // for example, if 3 clusters are selected, the linear gradient stop locations should be 0%, 50% and 100%
        clusters === null || clusters === void 0 ? void 0 : clusters.forEach(({ tagBackgroundColor }, index)=>{
            // add separator in every chunk instead of last chunk
            const separator = index === clusters.length - 1 ? "" : ", ";
            const color = isHover ? getHoverColor(colors[tagBackgroundColor]) : colors[tagBackgroundColor];
            colorsString += `${color}${LIGHT_THEME_BUTTON_OPACITY} ${chunkSize * index}%${separator}`;
        });
        return `linear-gradient(90deg, ${colorsString})`;
    };
    const saveClustersOnSignup = ()=>{
        trackEvent(SIGNUP_WITH_TAGS, {
            info1: clusters.map((tag)=>tag.tagText)
        });
        const clustersToUpdate = clusters === null || clusters === void 0 ? void 0 : clusters.map((tag)=>{
            const clusterId = tag.overridePageCluster;
            const useCaseId = tag.overridePageSubCluster;
            const res = [];
            clusterId && res.push({
                clusterId,
                clusterType: CLUSTER_TYPE
            });
            if (useCaseId) {
                const extraData = clusterId ? {
                    parent_cluster_id: clusterId
                } : {};
                res.push({
                    clusterId: useCaseId,
                    clusterType: USE_CASE_TYPE,
                    extraData
                });
            }
            return res;
        });
        const flattenedArray = clustersToUpdate.flat();
        if (flattenedArray.length > 0) {
            // fire each cluster id as an event, so filtering can be fully customized on Hotjar side
            fireHotjarEvents(flattenedArray.map((cluster)=>`tag_selected_${cluster.clusterType}_${cluster.clusterId}`));
            updateUserClustersListWithMultipleClusters(flattenedArray, HP_TAGS_SELECTION);
        }
    };
    return /*#__PURE__*/ _jsx(StyledClustersSignup, {
        background: getButtonColorBySelectedClusters(),
        textColor: getButtonTextColor(),
        className: classnames("clusters-signup", {
            "cluster-selected": wasClusterSelected
        }),
        children: /*#__PURE__*/ _jsx("div", {
            onMouseEnter: ()=>setIsHover(true),
            onMouseLeave: ()=>setIsHover(false),
            className: "cta-wrapper",
            children: /*#__PURE__*/ _jsx(ProductSignUp, _object_spread_props(_object_spread({}, restOfConfig), {
                buttonSize: buttonSize || "",
                buttonColor: WORK_OS_IRIS_COLOR_NAME,
                productType: productType,
                skipUpdateCluster: false,
                beforeSubmitCallback: saveClustersOnSignup
            }))
        })
    });
};
export default ClustersSignup;
